import React from 'react';

const Story: React.FC = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-serif text-5xl font-light leading-tight tracking-tight text-gray-900 mb-6">
          Ready to remember?
        </h2>
        <p className="font-sans text-xl font-normal text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
          Join thousands of professionals who are building meaningful relationships that last.
        </p>
        <a href="https://www.relatable.one/signup" className="inline-block bg-gray-900 text-white px-8 py-4 rounded-md font-medium text-lg transition-all duration-200 hover:bg-gray-800">
          Try Relatable
        </a>
      </div>
    </section>
  );
};

export default Story; 